export default "__VITE_ASSET__D2V6Vs8E__"